/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
// eslint-disable-next-line react/prop-types
function UploadFileIcon({ width = 50, height = 50, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 111 138"
      fill="none"
      {...props}
    >
      <path
        d="M48.6221 115.799H62.1221V87.4162L73.0028 98.297L82.4528 88.7186L55.3721 61.6378L28.2914 88.7186L37.9102 98.1283L48.6221 87.4162V115.799ZM15.3564 137.744C11.1058 137.744 7.48378 136.247 4.49027 133.254C1.49676 130.26 0 126.638 0 122.388V15.3564C0 11.1058 1.49676 7.48378 4.49027 4.49027C7.48378 1.49676 11.1058 0 15.3564 0H69.4371L110.744 41.3071V122.388C110.744 126.638 109.247 130.26 106.254 133.254C103.26 136.247 99.6384 137.744 95.3878 137.744L15.3564 137.744ZM61.6378 49.1064V15.3564H15.3564V122.388H95.3878V49.1064H61.6378Z"
        fill="#005AD2"
      />
    </svg>
  );
}
export default UploadFileIcon;
